// extracted by mini-css-extract-plugin
export default {"root":"SxLScnDzne8ZL1MrBNaB","label":"ucSGirTIZUAracdeWPEI","placeHolderShimmer":"jCzE3_fpEqOlPgGJlSfM"};